import m, { redraw } from 'mithril'
import { capitalise_first, get_publish_date, get_words_info, make_url_friendly, parse_text_to_lines, oxford_comma, quotify, commaify_words } from '../../logic/Formatter'
import Menu from '../../models/Menu'
import Stories from '../../models/Stories'

import sharelinks from '../components/sharelinks'
import popup from '../components/popup'


import { up_arrow, down_arrow, up_circle, down_circle, download, share, info_icon, star_icon } from '../components/icons'
import breadcrumbs from '../components/breadcrumbs'
import Genres from '../../models/Genres'

const base_image_url = 'https://libraryofshortstories.s3.ap-southeast-2.amazonaws.com/small/'
const base_image_url_2 = 'https://libraryofshortstories.s3.ap-southeast-2.amazonaws.com/covers/full/'

const Page = {

    oninit: vnode => {

        fetch('/links/' + vnode.attrs.story)
            .then(json_result => json_result.json())
            .then(result => {
                if (result.length) {
                    vnode.state.has_physical = result[0]
                    m.redraw()
                }
            })

        vnode.state.show_scroller = true

        Stories.fetch_story_metadata(vnode.attrs.story, story_info => {
            vnode.state.story_info = story_info
            redraw()
        },
            false,
            () => {
                vnode.state.no_metadata = true
            }
        )

        Stories.fetchtxt_gzip(vnode.attrs.story, (result => {
            vnode.state.text = result
            vnode.state.lines = parse_text_to_lines(vnode.state.text)
            redraw()
        }),
            (error) => {
                vnode.state.error = '404 - Story Not Found'
                vnode.state.no_text = true
                m.redraw()
            })
    },

    oncreate: (vnode) => {
        let content_element = document.getElementById('website')

        content_element.onscroll = (e) => {
            vnode.state.percentage_scrolled = Math.round(100 * (e.target.scrollTop) / (e.target.scrollHeight - e.target.clientHeight))
            m.redraw()
        }
    },

    view: function (vnode) {
        if (
            vnode.state.story_info && vnode.state.story_info.removed
        ) {

            return [

                m('.page.story_page',

                    m('h1',
                        m('', 'Story Removed'),
                        m('a.my_link', {
                            href: '/stories',
                        }, 'Keep Searching')
                    )
                )
            ]
        }

        if (
            vnode.state.error
        ) {

            return [

                m('.page.story_page',

                    m('h1',
                        m('', vnode.state.error),
                        m('a.my_link', {
                            href: '/stories',
                        }, 'Keep Searching')
                    )
                )
            ]
        }

        return [
            m(breadcrumbs, {
                links: ['/stories'],
                title: vnode.state.story_info?.title
            }),
            vnode.state.show_scroller ? m('.scroll_display', {
                style: 'width: ' + vnode.state.percentage_scrolled + '%;',
                class: Menu.content_size == 2 ? 'reverse' : ''
            }) : [],
            m(reading_options, {
                story_info: vnode.state.story_info,
                percentage_scrolled: vnode.state.percentage_scrolled,
                change_showing_info: (showing_info) => { vnode.state.showing_info = showing_info },
                toggle_scroller: (toggle) => vnode.state.show_scroller = toggle

            }),

            vnode.state.showing_info ? m('', {
                // class: (vnode.state.showing_info ? '' : 'd_none')
            },
                m(popup,
                    {
                        on_click_outside: () => vnode.state.showing_info = false,
                        class: 'dynamic_popup'
                    },
                    m('.online_reader_info',
                        m('p.or_title', vnode.state.story_info.title),
                        vnode.state.story_info?.series ? m('p.or_series.series_link.', `A `, m('a.my_link', { href: `/stories?search=${vnode.state.story_info.series}` }, `${vnode.state.story_info.series}`), ` story`) : [],

                        m('p.or_author', vnode.state.story_info.author),
                        vnode.state.story_info.rating ? m('p.or_rating',

                            m('.small_rating',
                                // {
                                //     itemprop: vnode.state.story_info.rating ? 'rating' : null,
                                //     content: vnode.state.story_info.rating,
                                // },
                                m('.stars',
                                    [...Array(vnode.state.story_info.rating)].map(() => m(star_icon, { stroke: 'black' })),
                                )
                            )
                        ) : [],
                        vnode.state.story_info.publish_year ? m('p.or_published', m(publish_info, { story_info: vnode.state.story_info })) : [],
                        m('p.or_words', get_words_info(vnode.state.story_info.words)),
                        m('p.or_genres', vnode.state.story_info.genres.map(g => m('.or_genre', capitalise_first(g)))),
                        m('p.or_description', vnode.state.story_info.description),
                        m('p.or_blurb', m('i', vnode.state.story_info.blurb)),
                        vnode.state.has_physical ? m('p',
                            m('a.sponsor_link',
                                {
                                    href: vnode.state.has_physical.link,
                                    target: '_blank',
                                    rel: 'sponsored'
                                },
                                m('i', 'Buy in print'),
                                // m('i', vnode.state.story_info?.title), ' in print in ', m('i.sponsor_link', vnode.state.has_physical.title)),
                                // vnode.state.has_physical.tag ? m('.affiliate_tag', vnode.state.has_physical.tag
                            )
                            //: []

                            // m('.sponsor_link', , 'Purchase this book at ', vnode.state.has_physical.store)
                        ) : [],

                        m('button.centre.heavy_button.orange_heavy_button', {
                            oncreate: vnode => vnode.dom.focus(),
                            onclick: () => {
                                vnode.state.showing_info = false
                            }
                        }, 'Close')
                    )
                )
            ) : [],

            m('.page.story_page',
                {
                    itemscope: true,
                    itemtype: 'https://schema.org/ShortStory'
                },

                //TITLE
                m('h1',
                    {
                        itemprop: 'name'
                    },

                    vnode.state.story_info ? vnode.state.story_info.title : (
                        m('.word_shimmer', '-')//, 'Loading Story'
                    )),

                //AUTHOR
                m('a.story_info.my_link.author',
                    {
                        href: vnode.state.story_info ? ('/author/' + make_url_friendly(vnode.state.story_info.author)) : ''
                    },
                    m('h2',
                        {

                            itemprop: vnode.state.story_info ? 'author' : undefined,
                        },
                        vnode.state.story_info ? vnode.state.story_info.author : m('.thin_word_shimmer', '-'))
                ),

                //Translator
                vnode.state.story_info?.original_language ? m('.story_info.',
                    'Translated from ', vnode.state.story_info?.original_language,
                    ' by ', ((vnode.state.story_info?.translators && vnode.state.story_info?.translators.length) ? oxford_comma(vnode.state.story_info?.translators) : 'Unknown')
                ) : [],

                //Word Length
                m('.story_info.word_length',
                    {
                        itemprop: vnode.state.story_info ? 'wordCount' : undefined,
                        content: vnode.state.story_info ? vnode.state.story_info.words : undefined
                    },
                    vnode.state.story_info ? (commaify_words(vnode.state.story_info.words) + ' words') : (
                        m('.word_shimmer', '-')//, 'Loading Story'
                    )
                ),

                //GENRES
                m('.genres', vnode.state.story_info ? (vnode.state.story_info.genres).map(genre => (

                    m('a.my_link',
                        {
                            href: ('/collection/' + make_url_friendly(genre))
                        },
                        m('span',
                            {
                                itemprop: 'genre',
                            },
                            capitalise_first(genre)
                        )
                    )
                )) : [
                    [1].map(skeleton_genre => m('.word_shimmer', '-')
                    )
                ]),

                //PUBLISH YEAR
                vnode.state.story_info?.publish_year ? m('.story_info.publish_year',
                    {
                        itemprop: 'datePublished',
                        content: vnode.state.story_info?.publish_year,
                        date: vnode.state.story_info?.publish_year
                    },

                    m(publish_info, { story_info: vnode.state.story_info })

                ) : [],

                vnode.state.story_info?.has_review ? m('.story_info',
                    m('.has_review', 'This story has a recommendation!'),
                    m('a.my_link', { href: '/review/' + vnode.attrs.story },
                        'Read recommendation of ',
                        m('i', vnode.state.story_info?.title)
                        // quotify(vnode.state.story_info?.title)
                    )
                ) : [],


                //Content Warning
                (vnode.state.story_info?.content_warning && vnode.state.story_info?.content_warning.length) ? m('.story_info.content_warning',
                    m('.header', 'Content Warning'),
                    vnode.state.story_info?.content_warning.map(warning => [
                        m('.warning', warning),

                    ])
                ) : [],


                m(cover_block, { story: vnode.state.story_info }),



                m('.story_text',
                    {
                        itemprop: 'text',
                        class: (
                            vnode.state.story_info &&
                            vnode.state.story_info.genres &&
                            vnode.state.story_info.genres.includes('poetry')
                        ) ? 'poetry' : ''
                    },
                    m('.pre_story_line'),

                    vnode.state.lines ? vnode.state.lines.map((line, line_i) =>

                        m('p',
                            line.map((phrase, phrase_i) => {

                                return phrase.image ? [
                                    m('img', {
                                        src: base_image_url + phrase.image.src,
                                        alt: phrase.image.alt
                                    })
                                ] :
                                    phrase.italic ?
                                        m('i', phrase.text)
                                        :
                                        [
                                            (line_i == 0 && phrase_i == 0 && phrase.text.length > 250 && isAlpha(phrase.text[0])) ? [m('span.drop_cap', phrase.text[0]), phrase.text.slice(1)]
                                                :
                                                phrase.text

                                        ]
                            }
                            )
                        )
                    )
                        : m('.shimmer',
                            [...Array(40)].map(() => [
                                m('.shimmer_cover')
                            ])
                        )
                ),

                vnode.state.story_info?.series ? m('.story_info.series_link.', `More of `, m('a.my_link', { href: `/stories?search=${vnode.state.story_info.series}` }, `${vnode.state.story_info.series}`), ``) : [],


                vnode.state.has_physical ?
                    m('a.has_physical_box',
                        {
                            href: vnode.state.has_physical.link,
                            target: '_blank',
                            rel: 'sponsored'
                        },
                        m('.has_physical', 'Buy ',
                            m('i', vnode.state.story_info?.title), ' in print in ', m('i.sponsor_link', vnode.state.has_physical.title)),
                        vnode.state.has_physical.tag ? m('.affiliate_tag', vnode.state.has_physical.tag
                        ) : []

                    ) :

                    vnode.state.story_info?.words > 500 ? m("a.kofi_link.has_physical_box", {
                        "href": "https://ko-fi.com/evanclewis",
                        "title": "Support me on Ko-fi",
                    },
                        m('img.kofi_image',
                            {
                                src: base_image_url + 'kofi_bg_tag_white.png',
                                alt: "A link saying 'Support me on Ko-Fi'"
                            }
                        ),
                        m('', 'Any donation will help keep the library running ad-free, with regular updates of new stories and collections.')

                    ) : []


            )
        ]
    }

}


//share links
//scroll buttons
//download pdf
const reading_options = {

    oninit: vnode => {
        Menu.content_size = 1
        vnode.state.hiding = true
        vnode.state.closed = false
        redraw()

    },

    onremove: vnode => {
        Menu.content_size = 0
        redraw()
    },

    onbeforeupdate: vnode => {
        let scroll_height = document.getElementById('website').scrollTop
        if (scroll_height == 0) {
            vnode.state.at_top = true
        }
        else { vnode.state.at_top = false }
    },

    view: vnode => {
        return [

            m('.reading_options',
                {
                    class: (vnode.state.hiding ? 'hiding' : '') + ' ' + (vnode.state.closed ? 'closed' : '')
                },

                m('.all_options',
                    {
                        class: vnode.state.hiding ? 'shrunk' : ''
                    },

                    m('button.reading_options_button.to_top_button',
                        {
                            tabindex: vnode.state.hiding || vnode.state.closed ? -1 : undefined,
                            onclick: () => {
                                vnode.attrs.change_showing_info(true)
                            },
                        },
                        m('.text.absolute_centre',
                            m(info_icon),
                            'Info'
                        )
                    ),

                    m('button.reading_options_button.to_top_button',
                        {
                            class: vnode.state.at_top ? 'd_computer' : '',
                            tabindex: vnode.state.hiding || vnode.state.closed ? -1 : undefined,
                            onclick: () => {
                                document.getElementById('website').scrollTop = 0;
                            },
                        },
                        m('.text.absolute_centre',
                            m(up_circle),
                            'Top'
                        )
                    ),
                    m('button.reading_options_button.to_bottom_button',
                        {
                            class: vnode.state.at_top ? '' : 'd_computer',
                            tabindex: vnode.state.hiding || vnode.state.closed ? -1 : undefined,
                            onclick: () => {
                                document.getElementById('website').scrollTop = document.getElementById('website').scrollHeight;
                            },
                        },
                        m('.text.absolute_centre',
                            m(down_circle),
                            'Bottom'
                        )
                    ),

                    vnode.attrs.story_info ? m('a.reading_options_button.button.reading_options_button_download.pdf_version_button.',
                        {
                            class: "instructure_file_link instructure_scribd_file auto_open",
                            title: vnode.attrs.story_info.title + ' PDF',
                            tabindex: vnode.state.hiding || vnode.state.closed ? -1 : undefined,
                            href: '/storiespdf/' + vnode.attrs.story_info.code + '.pdf',
                            target: '_blank',
                        },
                        m('.text',
                            m(download),
                            'PDF'

                        ),
                    ) : [],

                    vnode.attrs.story_info ? m('a.reading_options_button.button.reading_options_button_download.epub_version_button',
                        {
                            class: "instructure_file_link instructure_scribd_file auto_open",
                            tabindex: vnode.state.hiding || vnode.state.closed ? -1 : undefined,
                            title: vnode.attrs.story_info.title + ' EPUB',
                            href: '/storiesepub/' + vnode.attrs.story_info.code + '.epub',
                            target: '_blank',
                        },
                        m('.text',
                            m(download),
                            'EPUB'
                        ),
                    ) : [],

                    m('button.reading_options_button.open_share_button',
                        {
                            tabindex: vnode.state.hiding || vnode.state.closed ? -1 : undefined,
                            onclick: () => {
                                vnode.state.sharing = true
                            },
                        },
                        m('.text.absolute_centre',
                            m(share),
                            'Share'
                        )
                    ),
                ),

                vnode.state.sharing ? m(popup,
                    {
                        class: 'bordered',
                        on_click_outside: () => vnode.state.sharing = false
                    },
                    m(sharelinks, {
                        link: window.location.href,
                        title: vnode.attrs.story_info?.title
                    })) : [],


                !vnode.state.hiding ? [
                    !vnode.state.closed ?
                        m('button.close_toggle.close_toggle_bordered.open', {
                            onclick: () => {
                                Menu.content_size = 1
                                vnode.state.closed = true
                                vnode.state.hiding = true
                                vnode.attrs.toggle_scroller(false)

                            },
                            title: 'Unsticky Options'
                        },
                            m('.options_button_pair',
                                m('.x_icon', m('.x_icon_line_1'), m('.x_icon_line_2')),
                                m('', m('.text', ['Unsticky', m('span.di_computer', ' Options')])),
                            )
                        ) : [],

                    m('button.hide_toggle.hide_toggle_bordered.open', {
                        onclick: () => {
                            vnode.state.hiding = true
                            Menu.content_size = 1
                            redraw()
                        },
                        title: 'Hide Options'
                    },
                        m('.options_button_pair',
                            m(up_arrow, { resize: true, stroke_width: 1.2, class: "collapse_arrow" }),
                            m('', m('.text', ['Hide', m('span.di_computer', ' Options')])),
                        )
                    )

                ] :
                    [
                        !vnode.state.closed ? m('button.close_toggle.', {
                            onclick: () => {
                                Menu.content_size = 1
                                vnode.state.closed = true
                                vnode.state.hiding = true
                                vnode.attrs.toggle_scroller(false)
                            },
                            title: 'Unsticky Options'
                        },
                            m('.options_button_pair',
                                m('.x_icon', m('.x_icon_line_1'), m('.x_icon_line_2')),
                                m('', m('.text', ['Unsticky', m('span.di_computer', ' Options')])),
                            )
                        ) : [],

                        m('button.hide_toggle', {
                            onclick: () => {
                                vnode.state.hiding = false
                                vnode.state.closed = false
                                Menu.content_size = 2
                                vnode.attrs.toggle_scroller(true)
                                redraw()
                            },
                            title: 'Show Options'
                        },
                            m('.options_button_pair',
                                m(down_arrow, { resize: true, stroke_width: 1.2, class: 'collapse_arrow' }),
                                m('', m('.text', [m('span.di_computer', 'Show'), ' Options'])),
                            )
                        )
                    ]
            )
        ]
    }
}


const publish_info = {
    view: vnode => {
        return [
            get_publish_date(vnode.attrs.story_info),

            vnode.attrs.story_info?.publish_source ? [
                ' in ',
                m('a',
                    {
                        //If there is no edition (E.g. it is from a book) then the source is the link
                        href: (vnode.attrs.story_info.publish_scan && !vnode.attrs.story_info.publish_edition) ? vnode.attrs.story_info.publish_scan : undefined,
                        target: '_blank',
                        class: (vnode.attrs.story_info.publish_scan && !vnode.attrs.story_info.publish_edition) ? 'external_link' : ""
                    },

                    m('i', vnode.attrs.story_info.publish_source),
                ),
                vnode.attrs.story_info.publish_edition ? [
                    ', ',
                    m('a',
                        {
                            href: vnode.attrs.story_info?.publish_scan,
                            target: '_blank',
                            class: vnode.attrs.story_info?.publish_scan ? 'external_link' : ''
                        },
                        vnode.attrs.story_info?.publish_edition
                    )
                ] : []
            ] : []
        ]
    }
}

const cover_block = {

    oninit: vnode => {
        vnode.state.regulated = true
    },

    view: vnode => {
        let story = vnode.attrs.story
        return [

            m('.story_image',
                {
                    onclick: () => {
                        if (story && story.unique_cover) {
                            vnode.state.regulated = !vnode.state.regulated
                            m.redraw()
                        }
                    },
                    class: `${vnode.state.regulated ? 'regulated' : ''} ${story && story.unique_cover ? ' cursor_pointer' : ''}`
                },

                story?.image ?

                    m(cover_image, { story: story }) : [],
                (story && !story.unique_cover) ? m('.image_shade', {
                    style: (story?.genres && Genres.list.find(g => g.code == story?.genres[0]) ? ('background-color: ' + Genres.list.find(g => g.code == story?.genres[0]).colour)
                        : '')
                }) : []
            ),
        ]
    }
}

const cover_image = {

    view: vnode => {
        let story = vnode.attrs.story
        if (!story) return
        let image
        let image_alt
        if (story.unique_cover) {
            image = (base_image_url_2 + story.code.replace(/-/g, '_') + '.jpg')
            if (typeof story.unique_cover == 'string') image_alt = story.unique_cover
        }
        else {
            image = (base_image_url + story.image)
            image_alt = story.image_alt
        }


        return m('img.', {
            alt: image_alt,
            src: image,
            style: (story && !story.unique_cover) ? (story.genres ? Genres.get_style(Genres.list.find(g => g.code == story?.genres[0]).hue) : '') : '',
        })
    }
}

var isAlpha = function (ch) {
    return /^[A-Z]$/i.test(ch);
}


export default Page